import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layouts from '../../../components/Layouts';
import { getDirectusClient } from '../../../lib/directus';
import { readItems, readUsers } from '@directus/sdk';

import { useSelector } from 'react-redux';
import { Button, Table, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

function Vendedores() {
  const { idruta, nombreruta } = useParams();
  const navigate = useNavigate(); // Utilizado para navegar a una ruta específica
  const userdata = useSelector((state) => state.userdata);
  const [vendedores, setVendedores] = useState([]);
  const [loading, setLoading] = useState(false);

  const getVendedores = async () => {
    setLoading(true);
    try {
      const directus = await getDirectusClient();

      // 1. Obtener los circuitos asociados a la ruta
      const circuitos = await directus.request(
        readItems('circuitos', {
          fields: ['id', 'nombre'], // Solo necesitamos los IDs de los circuitos
          filter: {
            ruta: { _eq: idruta }, // Filtrar por la ruta específica
          },
        })
      );

      // Array para almacenar los usuarios únicos
      const usuariosUnicos = new Map();

      // 2. Recorrer los circuitos y obtener los usuarios asociados
      for (const circuito of circuitos) {
        const usuarios = await directus.request(
          readUsers({
            fields: ['id', 'first_name', 'last_name', 'email'], // Campos que necesitas
            filter: {
              circuitos_vendedor: {
                _eq: circuito.id , // Filtrar por el ID del circuito actual
              },
            },
          })
        );

        // Agregar usuarios al mapa para evitar duplicados
        
        
        usuarios.forEach((usuario) => {
          if (!usuariosUnicos.has(usuario.id)) {
            usuariosUnicos.set(usuario.id, { ...usuario, circuito: circuito.nombre });
          }
        });
      }

      // Convertir el mapa a un array
      setVendedores(Array.from(usuariosUnicos.values()));
    } catch (error) {
      console.error("Error fetching vendedores:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Nombre",
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Apellidos",
      dataIndex: "last_name",
      key: "last_name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {

      title: "Circuito",
      dataIndex: "circuito",
      key: "circuitos_vendeodor.circuitos_id.nombre",
    
    }
  ];

  useEffect(() => {
    getVendedores();
  }, []);

  return (
    <Layouts>
      <h1>Lista de vendedores de ruta {nombreruta}</h1>
      <Button type="primary"  icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>Atrás</Button> {/* Botón para ir atrás */}
      <Table
        dataSource={vendedores}
        columns={columns}
        loading={loading}
        rowKey="id"
      />
    </Layouts>
  );
}

export default Vendedores;